'use strict';

var PricingAnalysisPanelController = function PricingAnalysisPanelController($scope, $rootScope, searchCriteriaConstantsService, dataRetrieverConstantsService) {
  $scope.initialScreen = searchCriteriaConstantsService.PRICING_ANALYSIS;
  $scope.screen = dataRetrieverConstantsService.PRICING_ANALYSIS_SCREEN;
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
};
PricingAnalysisPanelController.$inject = ['$scope', '$rootScope', 'SearchCriteriaConstantsService', 'DataRetrieverConstantsService'];
module.exports = PricingAnalysisPanelController;